import { makeStyles } from "@mui/styles";
import { Theme } from "@mui/material/styles/createTheme";

export const useStyles = makeStyles((theme: Theme) => ({
    gridItem: {
        display: "flex",
        flexDirection: "column",
        width: "100%",
        height: "100%",
        borderBottom: `1px solid ${theme.palette.border.main}`,
        borderRadius: theme.spacing(1),
        boxShadow: "0px 2px 9px rgba(19, 61, 133, 0.15)",
        background: theme.palette.primary.main,
    },
    headerTitle: {
        height: "fit-content",
        width: "100%",
        padding: 8,
        display: "flex",
        borderBottom: `1px solid ${theme.palette.border.select}`,
        fontSize: 11,
        fontWeight: 700,
        textTransform: "uppercase",
        fontFamily: "Open Sans",
        color: theme.palette.info.main,
        justifyContent: "space-between",
        alignItems: "center",
    },
    content: {
        width: "100%",
        height: "100%",
        padding: 8,
        overflowY: "auto",
    },
    noData: {
        height: "100% !important",
        width: "100% !important",
    },
    headerActions: {
        marginLeft: theme.spacing(2),
    },
}));
